import { FC, ReactNode } from "react";
import { Typography } from "../../core/Typography/Typography";
import {
  TypographyColor,
  TypographyVariant,
} from "../../../constants/typography";
import { useStyles } from "./SettingRow.style";

interface ISettingRowProps {
  title: string;
  titleVariant?: TypographyVariant;
  description: string;
  control: ReactNode;
}

export const SettingRow: FC<ISettingRowProps> = ({
  title,
  titleVariant = TypographyVariant.BodyB5Bold,
  description,
  control,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.text}>
        <Typography variant={titleVariant}>{title}</Typography>
        <Typography
          variant={TypographyVariant.BodyB6Regular}
          color={TypographyColor.Silver}
        >
          {description}
        </Typography>
      </div>
      <div className={classes.control}>{control}</div>
    </div>
  );
};
